// Support-admin impersonation handoff (see beoflow copilot.views.impersonate_webapp).
//
// The Django admin redirects staff to `${WEBAPP_URL}/#imp=<code>`. The code is a
// single-use, 60s, one-time credential that AuthContext exchanges on boot for a
// short-lived access-only JWT. We read and STRIP the fragment before analytics
// init in main.tsx so the code can never ride the initial PostHog pageview
// ($current_url includes the fragment) into the event store.

const IMP_FLAG = 'impersonation'

let pendingCode: string | null = null

/** Read `#imp=<code>` from the URL, strip the fragment, and stash the code in
 *  memory (never localStorage) for AuthContext to exchange. Call ONCE, early. */
export function consumeImpersonationCodeFromUrl(): void {
  const params = new URLSearchParams(window.location.hash.slice(1))
  const code = params.get('imp')
  if (!code) return

  pendingCode = code
  params.delete('imp')
  const rest = params.toString()
  const url = new URL(window.location.href)
  url.hash = rest ? `#${rest}` : ''
  window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`)
}

/** Return and clear the stashed impersonation code (single-take). */
export function takePendingImpersonationCode(): string | null {
  const code = pendingCode
  pendingCode = null
  return code
}

/** True while an unexchanged impersonation code is stashed (non-consuming). */
export function hasPendingImpersonationCode(): boolean {
  return pendingCode !== null
}

export function markImpersonationSession() {
  localStorage.setItem(IMP_FLAG, '1')
}

export function clearImpersonationFlag() {
  localStorage.removeItem(IMP_FLAG)
}

export function isImpersonationSession(): boolean {
  return localStorage.getItem(IMP_FLAG) === '1'
}
